import routes from './routes/Routing';

function App() {
  return <div>{routes}</div>;
}

export default App;
